import { Location } from '@angular/common';
import { AfterViewChecked, Component, ElementRef, HostListener, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, combineLatest, debounce, distinctUntilChanged, iif, of, startWith, Subscription, switchMap, timer } from 'rxjs';
import { FieldBarraSecondaria, FieldConLinkSocial, FieldLinkSocial, Header, Subtree } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('menuMobileTrigger', [
      state('void', style({
        opacity: 0
      })),
      state('*', style({
        opacity: 1
      })),
      transition('void <=> *', animate('250ms ease-in-out'))
    ])
  ]
})
export class HeaderComponent implements OnInit, AfterViewChecked, OnDestroy {

  @Input() isPreview: boolean = false;
  public currentLang: string = '';
  public header: Header = new Header();
  public headerPathLogo: string = "";
  public headerAltLogo: string = "";
  public onChangeLang$: Subscription = new Subscription();
  public searchControl: FormControl = new FormControl('', [Validators.required]);
  public routerSearch: string = '';
  public inside: any = false;
  public itemIdClicked: string = '';
  public env = environment;
  public hoverSuperMenu = false;
  //MENU
  public isOpenMenu: boolean = false;
  public isOpenItemMenu: boolean = false;
  public contentMenu: Subtree = {} as Subtree;
  public showSearchBar: boolean = false;
  public typeSearch: string = 'SEARCH_BAR.PLACEHOLDER_SEARCH_ALL';
  private typeS: string = "search";
  private entity: string = "";
  public searchGlobal: FormControl = new FormControl("");
  public showSearch: boolean = false;
  public loginType: string = 'AUTH.LOGIN_TITLE';
  public contenutiPerType: string = 'TUTTI';
  public icon: string = '';
  public iconAlt: string = '';
  public chevronDirection: string = 'down';
  public isContenutiPerClicked: boolean = false;
  public isLoginTypeClicked: boolean = false;
  public barraTerziaria: FieldBarraSecondaria[] = []
  public barraSecondaria: any[] = []
  public itemBarraSecondaria: any[] = []
  public labelBarraTerziaria: any;
  public superMenu: boolean = false;
  public arrayFirstItem: FieldBarraSecondaria[] = [];
  public arraySecondItem: FieldBarraSecondaria[] = [];
  public arrayThirdItem: FieldBarraSecondaria[] = [];
  public arrayFourthItem: FieldBarraSecondaria[] = [];
  public arrayFifthItem: FieldBarraSecondaria[] = [];
  public arrayLinkSocialFirstItem: FieldLinkSocial[] = [];
  public arrayLinkSocialSecondItem: FieldLinkSocial[] = [];
  public arrayLinkSocialThirdItem: FieldLinkSocial[] = [];
  public arrayLinkSocialFourthItem: FieldLinkSocial[] = [];
  public arrayLinkSocialFifthItem: FieldLinkSocial[] = [];
  public arrayLoop: any = [];
  public arraySocialToLoop: FieldConLinkSocial[] = [];
  public arrayLogoSocials: any[] = [];
  public arrayUrl: any[] = []
  public titoliElementi: any = [];
  public socialsInTitle: any = [];
  public imageLanguages: any;
  public idItem: any;
  public tabContentHTML: any;
  public suggestions: any[] = [];
  private searchSelect: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public menuSecMobile: any[] = [];
  public classColumnTabSuperMenu: string = '';
  public indexColorHover: number | null = null; 
  public waitSuggestions = false;
  public languagesList :any[] = this.helpersService.languages;
  private pathSearch = "search";

  constructor(
    @Inject(HelpersService) public helpersService: HelpersService,
    public nodeService: NodeService,
    private elementRef: ElementRef,
    private router: Router,
    private location: Location,
    public navigationService: NavigationService
  ) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.checkRoute();
        this.suggestions = [];
        this.searchGlobal.reset();
        this.showSearchBar = false;
      }
    });
  }

  ngAfterViewChecked(): void {
    if (this.helpersService.isBrowser) {
      this.tabContentHTML = document.getElementById("myTabContent");
    }
  }

  ngOnInit(): void {
    this.currentLang = this.helpersService.lang;
    if (!this.helpersService.isBrowser) {
      this.getHeader();
      this.getFiltersView();
      this.changeTypeSearch();
    }
    this.onChangeLang$ = this.helpersService.onChangeLang.subscribe(langCode => {
      this.getHeader();
      this.getFiltersView();
      this.changeTypeSearch(this.typeS);

    });
    this.setImageLanguages();
    this.searchWithText();
  }

  ngOnDestroy(): void {
    if (this.onChangeLang$ instanceof Subscription) {
      this.onChangeLang$.unsubscribe();
    }
  }

  changeLang(lang: string): void {
    if (this.currentLang !== lang) {
      this.currentLang = lang;
      this.helpersService.useLanguage(lang);
      this.setImageLanguages(lang);
    }
  }

  public getHeader() {
    this.nodeService.getHeader(this.helpersService.langCodeApi, this.isPreview).subscribe((res: Header) => {
      this.header = res;
      // res.field_main_menu = res.field_main_menu.filter((m:any) => m.enabled);
      this.navigationService.headerMainMenu = res.field_main_menu;
      this.barraSecondaria = res.field_barra_secondaria;
      this.setMenuSecondarioMobile(res.field_barra_secondaria);
      this.arrayFirstItem = this.barraSecondaria[0].field_colonne_menu
      this.arraySecondItem = this.barraSecondaria[1].field_colonne_menu
      this.arrayThirdItem = this.barraSecondaria[2].field_colonne_menu
      this.arrayFourthItem = this.barraSecondaria[3].field_colonne_menu
      this.arrayFifthItem = this.barraSecondaria[4].field_colonne_menu
      this.arrayLinkSocialFirstItem = this.barraSecondaria[0].field_con_link_social
      this.arrayLinkSocialSecondItem = this.barraSecondaria[1].field_con_link_social
      this.arrayLinkSocialThirdItem = this.barraSecondaria[2].field_con_link_social
      this.arrayLinkSocialFourthItem = this.barraSecondaria[3].field_con_link_social
      this.arrayLinkSocialFifthItem = this.barraSecondaria[4].field_con_link_social
      for (const item of this.barraSecondaria) {
        for (const voice of item.field_colonne_menu) {
          for (let voiceB of voice.field_link_colonna) {
            if (voiceB.url.substring(0, 4) !== 'http') {
              voiceB.external = false;
            } else {
              voiceB.external = true;
            }
          }
        }
      }
      for (let item of this.barraSecondaria) {
        this.itemBarraSecondaria.push(item)
      }
      this.arrayLogoSocials = [];
      for (let social of this.header.field_link_social) {
        if (social.field_nome_social) {
          this.arrayLogoSocials.push(social.field_nome_social)
        }
        this.arrayLinkSocialSecondItem.push(social.field_link_social)
      }
      this.headerPathLogo = this.header.field_logo_universita[0].url;
      this.headerAltLogo = this.header.field_logo_universita[0].alt;
      // res.field_main_menu.forEach(menuItem => {
      //   if (menuItem.label === "News") {
      //     this.routerSearch = menuItem.link;
      //   }
      // });
      let i = 0;
      for (const voiceMenu of res.field_main_menu) {
        voiceMenu.link = decodeURIComponent(voiceMenu.link);
        if (voiceMenu.highlight_news && voiceMenu.highlight_news.field_created_at) {
          voiceMenu.highlight_news.field_created_at = this.helpersService.dateItToUs(voiceMenu.highlight_news.field_created_at);
        }
        let voiceMenuDecoded = this.nodeService.decodeObject(voiceMenu);
        voiceMenu.menu_custom = this.createCols(voiceMenuDecoded.subtree);
      }
      this.checkRoute()
      this.checkInitialSelectContentFor();
    }, err => {
      this.nodeService.showError(err);
    })
  }

  public checkRoute() {
    for (let item of this.header.field_barra_terziaria) {
      for (let url of item.field_link_correlato) {
        if (this.helpersService.isBrowser) {
          if (window.location.pathname === url.url) {
            this.contenutiPerType = url.label.toUpperCase()
            return
          }
        }
      }
    }
  }

  private checkInitialSelectContentFor() {
    if(this.header.field_barra_terziaria && this.header.field_barra_terziaria.length){
      this.icon = `${this.env.urlApi}${this.header.field_barra_terziaria[0].field_icona_elemento_menu}`;
      this.iconAlt = this.header.field_barra_terziaria[0].field_link_correlato[0].label;
      this.contenutiPerType = this.header.field_barra_terziaria[0].field_link_correlato[0].label.toUpperCase();
    }
  }

  //Evento click esterno
  public closeHeader() {
    this.helpersService.menuHeaderOpenBS.next(false);
    this.helpersService.menuHeaderClickedIdBS.next("");
  }

  // @HostListener('document:click', ['$event']) 
  // public onClick(event: any) { 
  //     const clickedInside = this.elementRef.nativeElement.contains(event.target); 
  //     if (!clickedInside) { 
  //       this.inside = false;
  //       this.itemIdClicked = '';
  //     } 
  // }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth > 1022) {
      this.resetVariableMobile();
    }
    if (event.target.innerWidth < 1022) {
      this.resetVariableDesktop();
    }
  }

  itemClicked(idNumber: number, id: string, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    if (this.helpersService.menuHeaderClickedIdBS.value !== id) {
      this.helpersService.menuHeaderOpenBS.next(true);
      this.helpersService.menuHeaderClickedIdBS.next(id);
      // const idNumber = Number(id.replace(/\D/g, ""));
      this.idItem = idNumber;
      const item = this.header.field_main_menu[idNumber].subtree;
      if (item && item.length) {
        this.tabContentHTML?.classList.add("active-col");
        this.tabContentHTML?.classList.remove("disable-col");
      } else {
        this.tabContentHTML?.classList.remove("active-col");
        this.tabContentHTML?.classList.add("disable-col");  
      }
    } else {
      this.tabContentHTML?.classList.remove("active-col");
      this.tabContentHTML?.classList.add("disable-col");  
      this.helpersService.menuHeaderOpenBS.next(false);
      this.helpersService.menuHeaderClickedIdBS.next("");
    }
  }

  public contenutiPerClicked() {
    this.isContenutiPerClicked = !this.isContenutiPerClicked;
  }

  public loginTypeClicked() {
    this.isLoginTypeClicked = !this.isLoginTypeClicked;
  }

  @HostListener('document:click', ['$event'])
  closeSearchBar(event: any) {
    if(this.helpersService.isBrowser) {
      const clicked = this.elementRef.nativeElement.contains(event.target);
      if (!clicked || event.target.classList.contains('container-list-second-menu')) {
        this.showSearchBar = false;
        this.showSearch = false;
        this.tabContentHTML?.classList.remove("active-col");
        this.tabContentHTML?.classList.add("disable-col");
        this.suggestions = [];
        this.searchGlobal.reset();
        this.closeInputSearch();
      }
    }
  }

  public showSearchB() {
    this.showSearchBar = true;
    this.showSearch = false;
    if (this.header.field_main_menu[this.idItem]) {
      const item = this.header.field_main_menu[this.idItem].subtree;
      if (item && item.length) {
        // this.tabContentHTML?.classList.add("active-col");
        // this.tabContentHTML?.classList.remove("disable-col");
      }  
    }
  }

  public closeInputSearch() {
    this.showSearch = false;
    this.suggestions = [];
    this.searchGlobal.reset();
    this.showSearchBar = false;
    this.tabContentHTML?.classList.remove("active-col");
    this.tabContentHTML?.classList.add("disable-col");
  }

  public changeTypeSearch(type?: string) {
    if (type == 'search') {
      this.typeSearch = this.nodeService.getIstant(`HEADER.DROPDOWN_SEARCH.ALL`);
      this.typeS = type;
      this.entity = "";
      this.pathSearch = "search"
    }
    if (type == 'faqs') {
      this.typeSearch = this.nodeService.getIstant(`HEADER.DROPDOWN_SEARCH.FAQ`);
      this.typeS = type;
      this.entity = "faq-procedure";
      if (this.helpersService.langCodeApi === "en") {
        this.pathSearch = "en/all-faqs-and-procedures"
      } else {
        this.pathSearch = "it/tutte-le-faq-procedure"
      }
    }
    this.searchSelect.next(this.entity);
  }

  public searchWithFilter() {
    const text = this.searchGlobal.value;
    const entity = this.entity;
    if (text) {
      if (entity === "faq-procedure") {
        this.router.navigateByUrl(`${this.pathSearch}?entity=${entity}&text=${text}`);
      } else {
        this.router.navigate(
          [this.pathSearch],
          { queryParams: { text: text } }
        );
      }
    }
    this.closeSearchBar('');

  }

  private searchWithText(): void {
    combineLatest({
      entity: this.searchSelect,
      searchGlobal: this.searchGlobal.valueChanges
    }).pipe(
      debounce(() => timer(1000)),
      distinctUntilChanged(),
      switchMap(valueSearch => {
        this.waitSuggestions = true;
        return iif(
          () => (valueSearch.searchGlobal !== '' && valueSearch.searchGlobal !== null) && valueSearch.entity === '',
          this.nodeService.getSearch(this.currentLang.split('-')[0], `text=${valueSearch.searchGlobal}`),
          iif(() => (valueSearch.searchGlobal !== '' && valueSearch.searchGlobal !== null) && valueSearch.entity === 'faq-procedure', 
          this.nodeService.getView(this.currentLang.split('-')[0], 'total-results', 'faq-procedure', `text=${valueSearch.searchGlobal}`, 0),
          of(''))
        );
      })
      // switchMap(valueSearch => iif(() => 
      //   (valueSearch.searchGlobal !== '' && valueSearch.searchGlobal !== null) && valueSearch.entity === '', 
      //   this.nodeService.getSearch(this.currentLang.split('-')[0], `text=${valueSearch.searchGlobal}`), 
      //   iif(() => (valueSearch.searchGlobal !== '' && valueSearch.searchGlobal !== null) && valueSearch.entity === 'faq-procedure', 
      //   this.nodeService.getView(this.currentLang.split('-')[0], 'total-results', 'faq-procedure', `text=${valueSearch.searchGlobal}`, 0), 
      //   of('')))
      // )
    ).subscribe(result => {
      this.waitSuggestions = false;
      let arrSug: any[] = [];
      if (result && result.rows && result.rows.length) {
        result.rows.forEach((el: any, idx: number) => {
          if (idx < 5) {
            arrSug.push(this.nodeService.retriveLinkTagA(el.field_titolo, 'a'));
          }
        });
      }
      this.suggestions = arrSug;
      // Mi metto in ascolto dei due observable, su uno emette, do un timer a 1 sec e verifico che la parola non sia uguale alla precedente
      // con lo switchMap, faccio il mio if, per verificare se la ricerca è per tutto il sito. Se non passa la condizione
      // entra il secondo if per vedere se è una faq. Altrimenti parte un observable vuoto (caso: chiusura barra di ricerca)
    }, err => {
      this.waitSuggestions = false;
    });
  }


  public changeLogin(type: string) {
    switch (type) {
      case 'lumsa':
        window.open(environment.urlApi, '_blank');
        break;
      case 'mialumsa':
        window.open('https://servizi.lumsa.it');
        break;
      case 'intranet':
        window.open('https://intranet.lumsa.it')
        break;
      default:
        this.loginType = 'AUTH.LOGIN_TITLE';
    }
    this.isLoginTypeClicked = !this.isLoginTypeClicked
  }

  public changeContenutiPer(item :any) {
    this.icon = `${this.env.urlApi}${item.field_icona_elemento_menu}`;
    this.contenutiPerType = item.field_link_correlato[0].label;
    this.router.navigate([item.field_link_correlato[0].url]);
    this.chevronDirection = 'down';
    this.isContenutiPerClicked = !this.isContenutiPerClicked;
  }



  openMenu() {
    if (!this.isOpenMenu && this.isOpenItemMenu) {
      this.isOpenMenu = false;
    } else if (this.isOpenMenu && !this.isOpenItemMenu) {
      this.isOpenMenu = false;
    } else {
      this.isOpenMenu = true;
    }
    this.isOpenItemMenu = false;
    this.helpersService.menuIsOpen.next(this.isOpenMenu);
  }

  openItemMenu(idx: number) {
    this.isOpenItemMenu = !this.isOpenItemMenu;
    this.isOpenMenu = false;
    this.contentMenu = this.nodeService.decodeObject(this.header.field_main_menu[idx]);
    this.helpersService.menuIsOpen.next(this.isOpenItemMenu);
  }

  returnToMenu() {
    this.isOpenItemMenu = false;
    this.isOpenMenu = true;
    this.helpersService.menuIsOpen.next(this.isOpenMenu);
  }

  resetVariableDesktop() {
    this.helpersService.menuHeaderOpenBS.next(false);
    this.helpersService.menuHeaderClickedIdBS.next("");
    this.tabContentHTML?.classList.remove("active-col");
    this.tabContentHTML?.classList.add("disable-col");  
  }

  resetVariableMobile() {
    this.isOpenItemMenu = false;
    this.isOpenMenu = false;
    this.helpersService.menuIsOpen.next(this.isOpenMenu);
  }

  createCols(subtree: any) {
    let i = 0;
    let voicesMenu: any = [];
    let tempMenu: any = [];
    for (const subtreeItem of subtree) {
      if (i === 0 || subtreeItem.link != "") {
        tempMenu.push(subtreeItem);
      }
      if ((i != 0 && subtreeItem.link === "") || (subtree.length - 1) === i) {
        voicesMenu.push(tempMenu);
        tempMenu = [];
        tempMenu.push(subtreeItem);
      }
      i++;
    }
    return voicesMenu;
  }

  public changeChevronDirection() {
    if (this.chevronDirection === 'down') {
      this.chevronDirection = 'up';
    } else {
      this.chevronDirection = 'down'
    }
  }

  public showSuperMenu(event: any) {
    if (event.target.dataset.indexLi) {
      const i = Number(event.target.dataset.indexLi);
      this.indexColorHover = i;
      if (this.hoverSuperMenu) {
        this.switchTabSuperMenu(i);
      } else {
        this.hoverSuperMenu = true;
        setTimeout(() => {
          if (this.hoverSuperMenu) {
            this.switchTabSuperMenu(i);
          }
        }, 800)
      }
    }
  }

  leaveSuperMenu() {
    this.hoverSuperMenu = false;
  }

  private switchTabSuperMenu(i: number) {
    this.superMenu = true
    this.getTitoliElementi(i)
    this.getSocialsInTitle(i)
    this.arrayLoop = this.barraSecondaria[i].field_colonne_menu;
    let count = 0;
    for (let i = 0; i < this.arrayLoop.length; i++) {
      if (this.arrayLoop[i].field_descrizione_colonna.length !== 0 || this.arrayLoop[i].field_link_colonna.length !== 0 || this.arrayLoop[i].field_titolo_colonna.length !== 0) {
        count++;
      }
    }
    if (count >= 4) {
      this.classColumnTabSuperMenu = 'col-2';
    } else {
      this.classColumnTabSuperMenu = 'col-3';
    }
  }

  private getTitoliElementi(i: any) {
    this.titoliElementi = this.barraSecondaria[i].field_titolo_elemento[0].value
  }

  private getSocialsInTitle(i: any) {
    this.socialsInTitle = this.barraSecondaria[i].field_con_link_social
  }

  @HostListener('document:mouseleave', ['$event'])
  public hideSuperMenu() {
    this.hoverSuperMenu = false;
    this.superMenu = false;
    this.indexColorHover = null;
  }

  private getFiltersView() {
    this.nodeService.getViewFilters(this.helpersService.langCodeApi).subscribe((res: any) => { });
    this.nodeService.getAvaiableTaxonomies(this.helpersService.langCodeApi, 1).subscribe((res: any) => { 
    }, err => {
      this.nodeService.getAvaiableTaxonomies(this.helpersService.langCodeApi, new Date().getTime()).subscribe();
    });
  }

  private setImageLanguages(langcode?: string): void {
    const lang = this.nodeService.lang;
    if (langcode) {
      this.languagesList.forEach(el => {
        if(langcode === el.code){
          this.imageLanguages = {
            url: el.url,
            text: el.text,
            type: el.code
          };
        }
      })

    } else {
      this.languagesList.forEach(el => {
        if (lang === el.code) {
          this.imageLanguages = {
            url: el.url,
            text: el.text,
            type: el.code
          };
        }
      })
    }
  }

  private setMenuSecondarioMobile(menu_secondario: any): void {
    this.menuSecMobile = menu_secondario.map((item: any) => {
      const titleAccordion = item.field_titolo_elemento[0].value;
      const contentAccordion = item.field_colonne_menu.filter((column: any) => column.field_titolo_colonna.length > 0 ||
      column.field_link_colonna.length
      ).map((column: any) => {
        const titleItem = column.field_titolo_colonna[0] ? column.field_titolo_colonna[0].value : "";

        column.field_descrizione_colonna = column.field_descrizione_colonna ? column.field_descrizione_colonna : [{value:""}];
        const contentItem = column.field_descrizione_colonna.map((text: any) => {
          return {
            value: text.value,
            
          };
        });
        
        const linkItem = column.field_link_colonna.map((link: any) => {
          return {
            label: link.label,
            url: link.url
          };
        });
        return {
          titleItem,
          contentItem,
          linkItem
        };
      });
      // }
      return {
        titleAccordion,
        contentAccordion
      };
    }).filter((item: any) => item.contentAccordion.length > 0);

  }
  
  
}
